/* eslint-disable prettier/prettier */
import React from 'react';
import { SimpleGrid, Card, CardBody, Flex, Box, Text, Spinner } from '@chakra-ui/react';
import { CurrencyDollar, Percent } from 'phosphor-react';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { formatarEmReais, formatarPercentual } from '../../../../../types/taxAnalysis';

interface TaxSummaryCardsProps {
  totalEmpresas: number;
  totalFaturamento: number;
  totalImpostos: number;
  mediaPercentual: number;
  isLoading: boolean;
}

export function TaxSummaryCards({
  totalEmpresas,
  totalFaturamento,
  totalImpostos,
  mediaPercentual,
  isLoading,
}: TaxSummaryCardsProps) {
  return (
    <Box mb={6}>
      <SimpleGrid columns={{ base: 2, xl: 4 }} spacing={{ base: 2, md: 4 }}>
        <Card shadow="sm" borderRadius="lg">
          <CardBody py={{ base: 2, md: 3 }} px={{ base: 2, md: 4 }}>
            <Flex align="center" gap={{ base: 2, md: 3 }}>
              <Box p={{ base: 1.5, md: 2 }} borderRadius="lg" bg="#E3F2FD" flexShrink={0}>
                <HiOutlineOfficeBuilding color="#1976D2" size={18} />
              </Box>
              <Box minW={0} flex={1}>
                <Text fontSize="2xs" color="gray.500" fontWeight="medium" mb={0.5} noOfLines={1}>
                  Total Empresas
                </Text>
                {isLoading ? (
                  <Flex align="center" h="24px">
                    <Spinner size="sm" />
                  </Flex>
                ) : (
                  <Text fontSize={{ base: 'sm', xl: 'lg' }} fontWeight="bold" color="gray.800">
                    {totalEmpresas}
                  </Text>
                )}
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card shadow="sm" borderRadius="lg">
          <CardBody py={{ base: 2, md: 3 }} px={{ base: 2, md: 4 }}>
            <Flex align="center" gap={{ base: 2, md: 3 }}>
              <Box p={{ base: 1.5, md: 2 }} borderRadius="lg" bg="#E8F5E9" flexShrink={0}>
                <CurrencyDollar color="#4CAF50" size={18} />
              </Box>
              <Box minW={0} flex={1}>
                <Text fontSize="2xs" color="gray.500" fontWeight="medium" mb={0.5} noOfLines={1}>
                  Total Faturamento
                </Text>
                {isLoading ? (
                  <Flex align="center" h="24px">
                    <Spinner size="sm" />
                  </Flex>
                ) : (
                  <Text
                    fontSize={{ base: 'xs', xl: 'sm' }}
                    fontWeight="bold"
                    color="gray.800"
                    noOfLines={1}
                  >
                    {formatarEmReais(totalFaturamento)}
                  </Text>
                )}
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card shadow="sm" borderRadius="lg">
          <CardBody py={{ base: 2, md: 3 }} px={{ base: 2, md: 4 }}>
            <Flex align="center" gap={{ base: 2, md: 3 }}>
              <Box p={{ base: 1.5, md: 2 }} borderRadius="lg" bg="#FFF3E0" flexShrink={0}>
                <CurrencyDollar color="#F57C00" size={18} />
              </Box>
              <Box minW={0} flex={1}>
                <Text fontSize="2xs" color="gray.500" fontWeight="medium" mb={0.5} noOfLines={1}>
                  Total Impostos
                </Text>
                {isLoading ? (
                  <Flex align="center" h="24px">
                    <Spinner size="sm" />
                  </Flex>
                ) : (
                  <Text
                    fontSize={{ base: 'xs', xl: 'sm' }}
                    fontWeight="bold"
                    color="gray.800"
                    noOfLines={1}
                  >
                    {formatarEmReais(totalImpostos)}
                  </Text>
                )}
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card shadow="sm" borderRadius="lg">
          <CardBody py={{ base: 2, md: 3 }} px={{ base: 2, md: 4 }}>
            <Flex align="center" gap={{ base: 2, md: 3 }}>
              <Box p={{ base: 1.5, md: 2 }} borderRadius="lg" bg="#FCE4EC" flexShrink={0}>
                <Percent color="#E91E63" size={18} />
              </Box>
              <Box minW={0} flex={1}>
                <Text fontSize="2xs" color="gray.500" fontWeight="medium" mb={0.5} noOfLines={1}>
                  Média % Impostos
                </Text>
                {isLoading ? (
                  <Flex align="center" h="24px">
                    <Spinner size="sm" />
                  </Flex>
                ) : (
                  <Text fontSize={{ base: 'sm', xl: 'lg' }} fontWeight="bold" color="gray.800">
                    {formatarPercentual(mediaPercentual)}
                  </Text>
                )}
              </Box>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Box>
  );
}
